export default "__VITE_ASSET__D48IkJRC__"